export const dynamicColumnsToShow = new Set(['creator_gender','audience_locations','audience_age','audience_gender','average_likes']);